import moment from 'moment';
import React, { useEffect, useState } from 'react'
import TableComponent from '../common/components/table';
import { Grid } from '@mui/material';
import CsaSignupStatusDetails from './csaSignupStatusDetails';
import { mapStateToProps } from '../../redux/reducers';
import { PropTypes } from "prop-types";
import * as actionTypes from "../../redux/actionTypes/csaSignup";
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {  removeSpecialCharacter } from '../../utils/globalMethods';
import { refreshKey } from "../../redux/actionTypes/administration";



function createData(id,isAction,startDate,endDate,setId,vendorId,clientId,shareId,vendorName, chosenNam,paymentType,shareName,shareCost,apprvlStatus,submittedDate, 
    agrmntAppId,clientNam,clientEmail,phoneNumber,lastUpdtUidNam,rejectedDate,address1,address2,city,state,zipcode,day,
    openTime,closeTime,dsc,cancelNotes,cancelESign,cancelDate,clientPreferdEmail,clientPreferdPhone,
    row
    ) {
      return {
        id,
        isAction,
        startDate ,//: paymentType === "MNTHLY" ? moment(startDate, "YYYY-MM-DD").format('MMM YYYY') :  moment(startDate, "YYYY-MM-DD").format('MM/DD/YYYY'),
        endDate, //: paymentType === "MNTHLY" ? moment(endDate, "YYYY-MM-DD").format('MMM YYYY') :  moment(endDate, "YYYY-MM-DD").format('MM/DD/YYYY'),
        setId,
        vendorId,
        clientId,
        shareId,
        vendorName,
        chosenNam,
        paymentType,
        shareName,
        shareCost,
        apprvlStatus,
        submittedDate :moment(submittedDate, "YYYY-MM-DD").format('MM/DD/YYYY'),
        agrmntAppId:agrmntAppId,
        clientNam :clientNam,
        clientEmail:clientEmail,
        phoneNumber:phoneNumber,
        lastUpdtUidNam:lastUpdtUidNam,
        rejectedDate:moment(rejectedDate, "YYYY-MM-DD").format('MM/DD/YYYY'),
        address1:address1,
        address2:address2,
        city:city,
        state:state,
        zipcode:zipcode,
        day : day,
        openTime : openTime,
        closeTime : closeTime,
        dsc:dsc,
        cancelNotes:cancelNotes,
        cancelESign:cancelESign,
        cancelDate:moment(cancelDate, "YYYY-MM-DD").format('MM/DD/YYYY'),
        clientPreferdEmail,
        clientPreferdPhone,
        row      
      };
    }

const CsaSignupStatusHistory = (props) => {

    const { row } = props;
    const navigate = useNavigate();

    const [size, setSize] = useState(10);
    const [from, setFrom] = useState(0);
    const [columns, setColumns] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [tableSort, setTableSort] = useState({ "lastUpdtTs": "DESC" });
    // eslint-disable-next-line no-unused-vars
    const [expand, setExpand] = useState(false);
    const [rows, setRows] = useState([]);
    const [csaSignupStatusTotal, setcsaSignupStatusTotal] = useState(0);
    const [showLoader, setShowLoader] = useState(true);
    // const [csaSignupStatusHistory, setCsaSignupStatusHistory] = useState([]);

    useEffect(() => {
        const userRole = props?.userAuth?.user ? props?.userAuth?.user : JSON.parse(sessionStorage.getItem("userData"));
        if (props?.allowedRoles) {
            const checkRole = props?.allowedRoles.find((role) => userRole?.Role?.includes(role));
            if (!checkRole) {
                navigate('/dtahip');
                return;
            }
        }
        const payload = {
          "setId": row?.setId,
          "id": row?.id,
        }
        props.getCsaSignupStatusHistory(payload);
    }, [size, from,props.csaSignup.refreshKey]);

    useEffect(() => {
        setShowLoader(true);
        
        const { list, total, loading } = props.csaSignup.csaSignupStatusHistory;
        let data = [];
        // setRows([]);
        setTimeout(() => {
            list.forEach(element => {
                data.push(createData(element.id, element?.isAction, element?.startDate, element?.endDate, element.setId, element.vendorId, element.clientId, element.shareInfo?.id, element?.vendorName, element?.chosenNam, element?.paymentType, element?.shareInfo?.nam, element?.shareInfo?.shareCost,
                    element?.apprvlStatus, element?.submittedDate, element?.agrmntAppId, element?.clientNam, element?.clientEmail,
                    element?.phoneNumber, element?.lastUpdtUidNam, element?.rejectedDate,
                    element?.shareInfo?.pickupInfo?.address1 ? element?.shareInfo?.pickupInfo?.address1 : element?.shareInfo?.deliveryInfo?.address1,
                    element?.shareInfo?.pickupInfo?.address2 ? element?.shareInfo?.pickupInfo?.address2 : element?.shareInfo?.deliveryInfo?.address2,
                    element?.shareInfo?.pickupInfo?.city ? element?.shareInfo?.pickupInfo?.city : element?.shareInfo?.deliveryInfo?.city,
                    element?.shareInfo?.pickupInfo?.state ? element?.shareInfo?.pickupInfo?.state : element?.shareInfo?.deliveryInfo?.state,
                    element?.shareInfo?.pickupInfo?.zipcode ? element?.shareInfo?.pickupInfo?.zipcode : element?.shareInfo?.deliveryInfo?.zipcode,
                    element?.shareInfo?.pickupInfo?.day, element?.shareInfo?.pickupInfo?.openTime, element?.shareInfo?.pickupInfo?.closeTime,
                    element?.shareInfo?.dsc, element?.cancelNotes, element?.cancelESign, element?.cancelDate,
                    element?.clientPreferdEmail, element?.clientPreferdPhone, element
                ));
            });
            setRows(data);
        handleColumns();
        setcsaSignupStatusTotal(total);
        setShowLoader(loading);
      }, 300);
    }, [props.csaSignup.csaSignupStatusHistory]);

    const handleColumns = () => { 
        const headers = [
          { id: "details", label: "Details" },
          { id: "vendorName", label: "Vendor Name",
            cell:(item) => {
              let status = " ";
              if(item.paymentType === "MNTHLY") {
                status = "Monthly"
                return( <><p>
                  {removeSpecialCharacter( item?.vendorName)}</p>
                  {status && <span className="badge badge-primary">{status}</span>}
                </>)
              }
              else {
                status = "Daily"
                return( <><p>
                  {removeSpecialCharacter( item?.vendorName)}</p>
                  {status && <span className="badge badge-grey">{status}</span>}
              </>
                )
              }
            }
          },
          {
            id: "clientNam",
            label: "Client Name",
            cell: (item) => {
              const fullName = item?.clientNam ? item?.clientNam : '-';
              const nameArray = fullName.split(' ');
              const firstName = nameArray[0];
              return <>
                <div  >
                  {fullName}
                  </div>
              </>;
            }
          },
          {
            id: "chosenNam",
            label: "Preferred Name",
            cell:(item) =>{
              return item?.chosenNam ? item?.chosenNam : <div style={{paddingLeft:"35px"}}>{"-"}</div>
            }
          },
          {
            id: "shareName",
            label: "Share Name",
          },
          {
            id: "shareCost",
            label: "Amount",
            cell:(item) => {
              return <div>{"$ " + item.shareCost}</div> 
           }
          },
          {
            id: "apprvlStatus",
            label: "CSA Signup status",
            cell: (item) => {
              let status="";
              if(item.apprvlStatus=="DRAFT"){
                status="Pending"; 
                return(<div style={{color:"#456F8F",fontWeight:"bold"}}> {status} </div>)}
              else if(item.apprvlStatus=="REJCTD"){
                status="Rejected"; 
                return(<div style={{color:"#dc3545" , fontWeight:"bold"}}> {status} </div>)}
    
              else if(item.apprvlStatus=="APPRVD"){
                status="Approved"; 
              return(<div style={{color:"#006e52" , fontWeight:"bold"}}> {status} </div>)}
    
              else if(item.apprvlStatus=="CANCLD"){
                status="Cancelled"; 
              return(<div style={{color:"#dc3545" , fontWeight:"bold"}}> {status} </div>)}
            }
          },
          {
            id: "startDate",
            label: "Share Start Date",
            cell: (item) => {
               const date = (item?.startDate === "Invalid date") ? <div style={{paddingLeft:"40px"}}>{"-"}</div> : (item?.paymentType === "MNTHLY" ? moment(item?.startDate, "YYYY-MM-DD").format('MMM YYYY') :  moment(item?.startDate, "YYYY-MM-DD").format('MM/DD/YYYY'));
               return <div>{date}</div>
            }
          },
          {
            id: "endDate",
            label: "Share End Date",
            cell: (item) => {
               const date = (item?.endDate === "Invalid date") ? <div style={{paddingLeft:"40px"}}>{"-"}</div> : (item?.paymentType === "MNTHLY" ? moment(item?.endDate, "YYYY-MM-DD").format('MMM YYYY') :  moment(item?.endDate, "YYYY-MM-DD").format('MM/DD/YYYY'));
               return <div>{date}</div>
            }
          },
          {
            id: "rejectedDate",
            label: "Approve/Reject Date",
            cell: (item) => {
               const date = (item?.rejectedDate === "Invalid date") ? <div style={{paddingLeft:"40px"}}>{"-"}</div> : item?.rejectedDate;
               return <div>{date}</div>
            }
           },
          {
            id:"submittedDate",
            label:"Signup Submitted Date"
          },
         
        ];
        setColumns(headers);
    };

    const handleNext = (page, rowSize) => {
        (size != rowSize) && setSize(rowSize);
        setFrom(rowSize * page);
    };

    const handleSort = (item) => {
        let sortitem = {};
        if (item.sort == "" || item.sort == "DESC") {
            sortitem[item.id] = "ASC";
        } else {
            sortitem[item.id] = "DESC";
        }
        setTableSort(sortitem);
    };

    const renderDetails = (row) => {
        return (
            <CsaSignupStatusDetails
                row={row}
            />

        );
    };


  return (
    <Grid container className="container-block" rowSpacing={2} role="region">
        <Grid item xs={12}>
            <TableComponent
            columns={columns}
            rows={rows}
            showDetails={true}
            expand={expand}
            renderDetails={renderDetails}
            handlePagination={handleNext}
            total={csaSignupStatusTotal}
            page={Math.floor(from / size)}
            rowsPerPage={size}
            handleSort={handleSort}
            dataLoading={showLoader}
            />
        </Grid>
    </Grid>
  )
}
CsaSignupStatusHistory.propTypes = {
    refreshKey: PropTypes.func.isRequired,
    getCsaSignupStatusHistory: PropTypes.func.isRequired,
    csaSignup: PropTypes.object.isRequired,
    row: PropTypes.object.isRequired,
    allowedRoles: PropTypes.array,
    userAuth : PropTypes.object,
  
}

function mapDispatchToProps(dispatch) {
    return {
      refreshKey: () => dispatch(refreshKey()),
      getCsaSignupStatusHistory: (payload) => dispatch(actionTypes.getCsaSignupStatusHistory(payload)),
  
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CsaSignupStatusHistory);